import { logger } from '@tunasong/models'
import { runEditorCommand, useEditor, useGlobalAppContext } from '@tunasong/plugin-lib'
import { useEffect } from 'react'
import { useUserConfig } from '../../config/config-service.hook.js'

/** Run the command on mount, or when any of the parameters change */
export const useRunEditorCommand = (props: { enterCommandId?: string; leaveCommandId?: string } | null) => {
  const { leaveCommandId, enterCommandId } = props ?? {}
  const [maturity] = useUserConfig('featureMaturity')
  const editor = useEditor({ allowNull: true })
  const globalContext = useGlobalAppContext()
  const plugins = editor?.meta.pluginList
  const [userConfig] = useUserConfig()

  useEffect(() => {
    if (!(enterCommandId || leaveCommandId)) {
      return
    }
    if (!(editor && plugins && userConfig)) {
      logger.warn(`Cannot run editor command without an editor context`, enterCommandId, leaveCommandId)
      return
    }
    if (enterCommandId) {
      void runEditorCommand({ commandId: enterCommandId, plugins, editor, maturity, globalContext, userConfig })
    }

    return () => {
      if (leaveCommandId) {
        void runEditorCommand({ commandId: leaveCommandId, plugins, editor, maturity, globalContext, userConfig })
      }
    }
  }, [editor, enterCommandId, plugins, globalContext, leaveCommandId, maturity, userConfig])
}
